var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _g, _circle2, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpinachMag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 96,
    viewBox: "0 0 108 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4368 64.553C61.9681 75.0131 51.1244 80.0297 44.2168 75.7579C37.3092 71.4861 36.9534 59.5436 43.4221 49.0835C49.8908 38.6234 60.7345 33.6068 67.6421 37.8786C71.1407 40.0422 67.5404 45.822 67.6421 50.7319C67.7412 55.516 71.6292 59.3908 68.4368 64.553Z",
    fill: "#7DBE81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1376 45.9613L37.9114 89.1492",
    stroke: "#3B593D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.583 46.5516L58.3964 54.0697",
    stroke: "#3B593D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5828 52.8512L50.6074 67.7679",
    stroke: "#3B593D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8279 60.0251L54.0245 61.398",
    stroke: "#3B593D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.1189,
    cy: 55.6987,
    rx: 14.7058,
    ry: 22.2688,
    transform: "rotate(-5.14188 35.1189 55.6987)",
    fill: "#96CD82"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0836 41.1592L39.5517 90.8749",
    stroke: "#3B593D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.887 48.1498L35.827 57.548",
    stroke: "#3B593D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3233 45.0417L35.2443 51.7399",
    stroke: "#3B593D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3173 61.3063L36.9649 67.0487",
    stroke: "#3B593D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0492 59.2554L37.1417 69.9815",
    stroke: "#3B593D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.764 39.2113C61.1448 40.122 59.7767 40.426 58.3188 41.4434C57.8032 41.8031 57.7818 43.0805 57.1216 43.3565C54.5945 44.4131 52.1281 44.2703 51.6127 43.0375C51.0973 41.8048 52.728 39.9489 55.2551 38.8923C57.7822 37.8357 60.2486 37.9786 60.764 39.2113Z",
    fill: "#C87749"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 32.5,
    r: 32.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.8246 94.2101C78.7727 120.085 51.8642 132.495 34.7231 121.927C17.5821 111.36 16.6992 81.8184 32.7511 55.9434C48.8031 30.0684 75.7115 17.6589 92.8526 28.226C101.534 33.5781 92.6002 47.8755 92.8526 60.021C93.0985 71.8554 102.747 81.4404 94.8246 94.2101Z",
    fill: "#7DBE81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6748 48.2201L19.0764 155.053",
    stroke: "#3B593D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9282 49.6803L69.9096 68.2777",
    stroke: "#3B593D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6313 65.2634L50.5813 102.163",
    stroke: "#3B593D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0994 127.172C37.1724 125.371 51.2274 99.3478 48.4923 69.0471C45.7571 38.7464 27.2674 15.6424 7.19445 17.443C-12.8785 19.2436 -26.9336 45.2668 -24.1984 75.5675C-21.4632 105.868 -2.97353 128.972 17.0994 127.172Z",
    fill: "#96CD82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7848 31.5227C76.7297 33.7755 73.3348 34.5275 69.7171 37.0442C68.4376 37.934 68.3845 41.0938 66.7462 41.7766C60.4753 44.3903 54.355 44.037 53.076 40.9875C51.797 37.9382 55.8436 33.3473 62.1145 30.7336C68.3855 28.1199 74.5058 28.4734 75.7848 31.5227Z",
    fill: "#C87749"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 34.5,
    r: 31.5,
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 87.4142,
    y1: 56,
    x2: 107,
    y2: 75.5858,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_590"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinachMag);
export default __webpack_public_path__ + "static/media/spinach_mag.c2d9e729bc53e8fd8b580e00f10147cb.svg";
export { ForwardRef as ReactComponent };